'use strict';

angular.module('app').directive('paymentInfo', function (Booking) {
  return {
    restrict: 'A',
    templateUrl: window.templatePath
      ? window.templatePath + 'templates/_payment-schedule.html'
      : '../templates/_payment-schedule.html',
    scope: {
      paymentInfo: '=',
      currency: '=',
      currencyToCharge: '=',
      amountTotal: '=',
      orderId: '=',
    },
    link: function (scope) {
      var requirePaymentConfirmation = _.find(scope.paymentInfo, {
        status: 60,
      });
      if (requirePaymentConfirmation) {
        Booking.verifyPayment(scope.orderId).then(function (data) {
          scope.paymentVerificationLink = data.confirmUrl;
        });
      }
    },
  };
});
